import { Button } from "@/components/ui/button";
import { Phone, ArrowDown } from "lucide-react";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import heroBg from "@/assets/hero-bg.jpg";

export const Hero = () => {
  const [showPhone, setShowPhone] = useState(false);
  const [currentText, setCurrentText] = useState(0);
  const texts = ["Firmowych", "Integracyjnych", "Okolicznościowych"];

  useEffect(() => {
    const phoneInterval = setInterval(() => {
      setShowPhone(prev => !prev);
    }, 3000);
    const textInterval = setInterval(() => {
      setCurrentText(prev => (prev + 1) % texts.length);
    }, 4000);
    return () => {
      clearInterval(phoneInterval);
      clearInterval(textInterval);
    };
  }, []);

  const scrollToContactForm = () => {
    document.getElementById('kontakt')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToAbout = () => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative min-h-[100vh] flex items-center justify-center bg-primary overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img src={heroBg} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-primary/75" />
      </div>

      {/* Animated background elements */}
      <div className="absolute inset-0">
        <div className="absolute w-[600px] h-[600px] bg-accent/10 rounded-full -top-48 -left-48 blur-3xl animate-float" />
        <div className="absolute w-[500px] h-[500px] bg-gold/5 rounded-full -bottom-32 -right-32 blur-3xl animate-float" style={{ animationDelay: "3s" }} />
        <div className="absolute w-[300px] h-[300px] bg-accent-glow/5 rounded-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 blur-3xl animate-pulse" />
      </div>

      <div className="container relative z-10 text-center px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="inline-block px-4 py-2 rounded-full text-sm font-medium bg-accent/10 text-accent border border-accent/20 mb-8">
            ⭐ Ponad 999 zrealizowanych wydarzeń
          </span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="font-montserrat text-5xl md:text-7xl lg:text-8xl font-black mb-8 text-white leading-tight"
        >
          Występy dla imprez<br />
          <span className="gradient-text transition-all duration-500">
            {texts[currentText]}!
          </span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="font-inter text-lg md:text-xl text-white/60 mb-12 max-w-2xl mx-auto leading-relaxed"
        >
          Profesjonalne występy artystyczne i komediowe, które sprawią, 
          że Twoje wydarzenie będzie niezapomniane.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Button 
            size="lg" 
            onClick={scrollToContactForm}
            className="bg-accent hover:bg-accent-light text-white text-lg px-8 py-6 rounded-xl font-semibold animate-glow-pulse w-[240px] flex items-center justify-center gap-2 transition-all duration-300 hover:scale-105"
          >
            {showPhone ? (
              <>
                <Phone className="w-5 h-5" />
                +48 533 333 993
              </>
            ) : (
              "Zamów występ"
            )}
          </Button>
          <Button 
            size="lg"
            variant="outline"
            onClick={scrollToAbout}
            className="border-white/20 text-white hover:bg-white/10 text-lg px-8 py-6 rounded-xl bg-white/5"
          >
            Dowiedz się więcej
          </Button>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 cursor-pointer"
        onClick={scrollToAbout}
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
        >
          <ArrowDown className="w-6 h-6 text-white/40" />
        </motion.div>
      </motion.div>
    </div>
  );
};
